import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetData, IDataReq } from '../models/certify.model';
import { IConfirmReq, IFindIdParams, IGenerateReq, IGetResult, IGetVerifyResult, IMemberCheckReq, IResetPasswordReq, IVerifyForPasswordReq } from '../models/auth.model';

const uri = '/service/join';

    export const generateCode = (data: IGenerateReq): AxiosPromise<IGetResult> => {
        return axios.post(`${uri}/certify/generate`, data);
    };

    export const confirmCode = (data: IConfirmReq): AxiosPromise<IGetResult> => {
        return axios.post(`${uri}/certify/confirm`, data);
    };

    export const verifyForPassword = (data: IVerifyForPasswordReq): AxiosPromise<IGetResult> => {
        return axios.post(`${uri}/find-password`, data);
    };




  export const generateCodeForId = (data: IDataReq): AxiosPromise<IGetData> => {
    return axios.post(`${uri}/sum/certify/generate`, data);
  }

  export const confirmCodeForId = (data: IConfirmReq): AxiosPromise<IGetResult> => {
    return axios.post(`${uri}/certify/confirm`, data);
  };

  export const findMemberId = (data: IFindIdParams): AxiosPromise<IGetResult> => {
    return axios.post(`${uri}/sum/find-id`, data);
  };

  export const findWebId = (data: IMemberCheckReq): AxiosPromise<IGetData> => {
    return axios.post(`${uri}/find-web-id`, data);
  }
  
  export const generateCodeForPassword = (data: IDataReq): AxiosPromise<IGetData> => {
    return axios.post(`${uri}/certify/generate`, data);
  }
  
  export const confirmCodeForPassword = (data: IDataReq): AxiosPromise<IGetData> => {
    return axios.post(`${uri}/certify/confirm`, data);
  }
  
  export const updatePassword = (data: IDataReq): AxiosPromise<IGetData> => {
    return axios.put(`${uri}/web-pass/change`, data);
  }

  export const resetPassword = (data: IResetPasswordReq): AxiosPromise => {
    return axios.post(`${uri}/reset-password`, data);
  };
